import { useEffect, useState, memo } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import defaultLogo from '../../assets/images/company/demo.jpg';
import MDBox from '../../components/MDBox';
import Loading from '../../components/Loading';

const imageCache = {}; // Oggetto cache per salvare le immagini già caricate

const LogoHeader = ({ image, url, company }) => {
  const [imagePath, setImagePath] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    if (!image) {
      console.log('no image', image);
      setImagePath(defaultLogo);
      return;
    }

    // Se l'immagine è già in cache, usala subito
    if (imageCache[image] && imagePath === defaultLogo) {
      console.log('image in cache', imageCache[image]);
      setImagePath(imageCache[image]);
      return; // Non aggiornare imagePath se è già in cache
    }

    const loadImage = async () => {
      try {
        import(`../../assets/images/company/${image}`)
          .then((module) => {
            console.info('loading image:', image);
            imageCache[image] = module.default;
            setImagePath(module.default);
          })
          .catch((error) => {
            console.error('Error loading image:', error);
            imageCache[image] = defaultLogo;
            setImagePath(defaultLogo);
          })
          .finally(() => {
            setLoading(false); // Fine caricamento
          });
      } catch (error) {
        imageCache[image] = defaultLogo; // Salva il fallback nella cache
        setImagePath(defaultLogo);
      } finally {
        setLoading(false);
      }
    };

    loadImage();
  }, [image]);

  return (
    <MDBox component={NavLink} to={url} display="flex" alignItems="center" sx={{ width: '98%' }}>
      {loading ? (
        <Loading width="99%" height={80} />
      ) : (
        <img
          src={imagePath}
          alt={company}
          style={{ width: '99%', borderRadius: '.5rem', height: '100%', objectFit: 'cover' }}
        />
      )}
    </MDBox>
  );
};
LogoHeader.displayName = 'LogoHeader';
LogoHeader.defaultProps = {
  image: 'demo.jpg',
  url: '#',
};
LogoHeader.propTypes = {
  image: PropTypes.string,
  url: PropTypes.string,
  company: PropTypes.string.isRequired,
};

export default memo(LogoHeader);
